import { render } from "./CommonMenu.vue?vue&type=template&id=5a47177a"
import script from "./CommonMenu.vue?vue&type=script&lang=js"
export * from "./CommonMenu.vue?vue&type=script&lang=js"

import "./CommonMenu.vue?vue&type=style&index=0&id=5a47177a&lang=scss"

import exportComponent from "E:\\公司项目\\双碳\\gdtt-front\\gdtt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__